import { GeolocationAddress } from '@wwt/entities/api/search-response'

export const getFullAddress = (address: GeolocationAddress) => {
	const { country, countryCode, city, streetAddress } = address

	return `${countryCode} ${country}, ${city}, ${streetAddress}`
}
